export interface Sex {
  text: string;
  value: string;
}

export const sexList: Sex[] = [
  {
    text: 'Female',
    value: 'Female',
  },
  {
    text: 'Male',
    value: 'Male',
  },
  {
    text: 'Undifferentiated',
    value: 'Other',
  },
  {
    text: 'Unknown',
    value: 'Unknown',
  },
];
